import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../shared/Spinner.jsx';
import { useAuth } from './AuthContext.js';

/**
 * Gate for the staff area. Note this is a convenience, not a security boundary:
 * every protected endpoint is guarded server-side, so bypassing this in the
 * browser gets you an empty page and a string of 401s.
 */
export default function RequireAuth({ children, requireAdmin = false }) {
  const { status, isSignedIn, isAdmin } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spinner label="Checking your session" />
      </div>
    );
  }

  if (!isSignedIn) {
    // `state` lets the login page send them back where they were headed.
    return <Navigate to="/staff/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="mx-auto max-w-[560px] px-5 py-24 text-center">
        <h1 className="font-display text-3xl font-extrabold text-forest">
          You do not have access to this page
        </h1>
        <p className="mt-3 text-ink-soft">
          This area is limited to administrators. Ask an administrator if you need access.
        </p>
      </div>
    );
  }

  return children;
}
